module.exports = __webpack_public_path__ + "img/banner2.32769cf8.png";